// src/components/MetronomeControls.tsx
import { memo } from 'react';
import '../styles/MetronomeControls.css';

interface MetronomeControlsProps {
  enabled: boolean;
  muted: boolean;
  onToggle: () => void;
  onMuteToggle: () => void;
}

export const MetronomeControls = memo(function MetronomeControls({
  enabled,
  muted,
  onToggle,
  onMuteToggle,
}: MetronomeControlsProps) {
  return (
    <div className="metronome-controls">
      <button
        data-testid="metronome-toggle"
        className={`metronome-toggle ${enabled ? 'active' : ''}`}
        onClick={onToggle}
        aria-pressed={enabled}
        aria-label={enabled ? 'Disable metronome' : 'Enable metronome'}
      >
        <span className="metronome-icon">♩</span>
        <span className="metronome-label">Metronome</span>
      </button>

      {enabled && (
        <button
          data-testid="metronome-mute"
          className={`metronome-mute ${muted ? 'muted' : ''}`}
          onClick={onMuteToggle}
          aria-pressed={muted}
          aria-label={muted ? 'Unmute metronome' : 'Mute metronome'}
        >
          {muted ? '🔇' : '🔊'}
        </button>
      )}
    </div>
  );
});
